import React, {Component} from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';

export default class SweetAlertDisplay extends Component {

    render() {
        const {
            title,

            confirmBtnBsStyle = 'default',
            cancelBtnBsStyle = 'default',

            children,
            ...restprops
        } = this.props;
        let {
            confirmBtnText = 'Gerai',
            cancelBtnText = 'Atšaukti'
        } = this.props;

        return (
            <SweetAlert title={title} confirmBtnBsStyle={confirmBtnBsStyle}
                        cancelBtnBsStyle={cancelBtnBsStyle}
                        {...restprops} cancelBtnText={cancelBtnText} confirmBtnText={confirmBtnText}>
                {children}
            </SweetAlert>);
    }

}



// WEBPACK FOOTER //
// ./src/js/components/sweet-alert.jsx